import { useCallback } from 'react';
import { startOfWeek } from 'date-fns';
import { Spinner } from '../common/Spinner';
import { WeekNavigation } from './WeekNavigation';
import { AlwaysRunningStrip } from './AlwaysRunningStrip';
import { WeekGrid } from './WeekGrid';
import { NextUpQueue } from './NextUpQueue';
import { useCalendarStore } from '../../stores/calendarStore';
import { usePolling } from '../../hooks/usePolling';

export default function CalendarPage() {
  const weekSchedule = useCalendarStore((s) => s.weekSchedule);
  const nextUp = useCalendarStore((s) => s.nextUp);
  const selectedDate = useCalendarStore((s) => s.selectedDate);
  const loading = useCalendarStore((s) => s.loading);
  const fetchWeekSchedule = useCalendarStore((s) => s.fetchWeekSchedule);
  const fetchNextUp = useCalendarStore((s) => s.fetchNextUp);
  const setSelectedDate = useCalendarStore((s) => s.setSelectedDate);

  const fetchAll = useCallback(async () => {
    await Promise.all([fetchWeekSchedule(), fetchNextUp()]);
  }, [fetchWeekSchedule, fetchNextUp]);

  usePolling(fetchAll, 60_000);

  const current = new Date(selectedDate + 'T12:00:00');
  const weekStart = startOfWeek(current, { weekStartsOn: 1 });

  // Filter out interval jobs from the week grid (they show in the strip)
  const cronSlots = weekSchedule.filter((s) => s.job_id !== 'budget-check');

  const isInitialLoad = loading && weekSchedule.length === 0;

  if (isInitialLoad) {
    return (
      <div className="flex items-center justify-center h-full">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div>
      <WeekNavigation selectedDate={selectedDate} onDateChange={setSelectedDate} />
      <AlwaysRunningStrip slots={weekSchedule} />

      <div className="flex flex-col lg:flex-row gap-4">
        <WeekGrid slots={cronSlots} weekStart={weekStart} />
        <NextUpQueue slots={nextUp} />
      </div>
    </div>
  );
}
